import AOS from 'aos';

AOS.init({
  once: true,
  offset: 100,
  startEvent: 'load',
});
AOS.refresh(true);

// set transition delay to zero
$(document).on('mouseover', '.aos-animate.aos-init', function () {
  $(this).addClass('aos-animation-ready');
});
